import { cx } from "@nju/css";
import { Icon, IconName } from "@nju/icons";

type BadgeVariant = "yellow" | "cerulean" | "dark";
type BadgeFontSize = 14 | 16;

export interface IBadgeProps {
  badgeText: string;
  name?: IconName;
  small?: boolean;
  variant?: BadgeVariant;
  fontSize?: BadgeFontSize;
}

export function Badge({
  badgeText,
  name,
  small = false,
  variant = "yellow",
  fontSize = 16,
}: IBadgeProps) {
  return (
    <div className="flex">
      <div
        className={cx("rounded-badge flex items-center z-3 gap-1", {
          "py-1 px-3": !small,
          "py-0 px-2": small,
          "text-size-14": fontSize === 14,
          "text-size-16": fontSize === 16,
          "bg-ripeLemon text-black": variant === "yellow",
          "bg-cerulean text-white": variant === "cerulean",
          "bg-[#00273F] text-white": variant === "dark",
        })}
      >
        {name && <Icon height={20} name={name} width={20} />}
        <span>{badgeText}</span>
      </div>
    </div>
  );
}
